import React, { useContext, useState, useCallback, useEffect } from 'react';

import PresentPC from 'components/pages/Input/PresentPC';
import PresentSP from 'components/pages/Input/PresentSP';
import AppContext from 'fluxes/context';

import {
  UPDATE_INPUT,
  CHANGE_VALID,
} from 'fluxes/actions';

import {
  useWindowDimensions,
  useIECheck,
  sortErrors,
  useDirectTransCheck,
  isSchemaValid,
  isCustomValid,
  MoveCheckStart,
  isFatalApiError,
  ErrorMessage,
  scrollTop,
  getCookies
} from 'utils';

import {
  ekiSuggestApi,
} from 'utils/api';

import {
  CHOICES_MAP,
  CUSTOM_ERROR_MESSAGES,
} from 'utils/constant';


const Input = () => {
  const path = window.location.pathname;
  const { state, dispatch } = useContext(AppContext);
  
  const[ workCategory, setWorkCategory ] = useState(state.workCategory);
  const[ workCategorySub, setWorkCategorySub ] = useState(state.workCategorySub);
  const[ workCategoryOtherDetail, setWorkCategoryOtherDetail ] = useState(state.workCategoryOtherDetail);
  const[ workDetailText, setWorkDetailText ] = useState(state.workDetailText);
  const[ employmentPlacementDispatching, setEmploymentPlacementDispatching ] = useState(state.employmentPlacementDispatching);
  const[ companyNameText, setCompanyNameText ] = useState(state.companyNameText);
  const[ dept, setDept ] = useState(state.dept);
  const[ chargePersonNameText, setChargePersonNameText ] = useState(state.chargePersonNameText);
  const[ tel, setTel ] = useState(state.tel);
  const[ email, setEmail ] = useState(state.email);
  const[ address, setAddress ] = useState(state.address);
  const[ selectedEkiCd, setSelectedEkiCd ] = useState(state.ekiCd);
  const[ ekiCd, setEkiCd ] = useState(state.ekiCd);
  const[ ekiName, setEkiName ] = useState(state.ekiName);
  const[ ekiSuggestNames, setEkiSuggestNames ] = useState([]);
  const [ modalBackIsEnable, setModalBackIsEnable ] = useState(false);
  const[ timerId, setTimerId ] = useState('');

  const [ clickID, setClickID ] = useState(state.clickID);
  const [ mediaID, setMediaID ] = useState(state.mediaID);

  useEffect(() => {
    setClickID(getCookies('click_id'));
      setMediaID(getCookies('media_id'));
  }, []);

  // レスポンシブ
  const { width } = useWindowDimensions();
  const isIE = useIECheck();
  const isSp = width <= 640 && !isIE;

  // 直接遷移チェック
  useDirectTransCheck({ state });
  MoveCheckStart();

  // 入力チェック用変数
  const initialValid = { valid: state.validMap[path], errorMessages: [] };
  const [ valids, setValids ] = useState({
    schema: initialValid,
    ekiSuggestZero: initialValid,
  });

  // 初期入力チェック設定
  const [ isShowError, setIsShowError ] = useState({
    workCategoryOtherDetail: false,
    workDetailText: false,
    companyNameText: false,
    dept: false,
    chargePersonNameText: false,
    tel: false,
    email: false,
    address: false,
    ekiCd: false,
    ekiName: false,
  });
  
  const [ isApiError, setIsApiError ] = useState(false);

  // エラーの画面表示で利用する値
  const valid = Object.keys(valids).every(key => valids[key].valid);
  console.log(`valid after declare: ${ valid}`);

  const dispErrors = useCallback(() => {
    const { schema, ekiSuggestZero } = valids;
    const errors = sortErrors([
      ...schema.errorMessages,
      ...ekiSuggestZero.errorMessages,
    ]);
    const errorMap = errors.reduce((obj, error) => {
      const { target, message } = error;
      if(!isShowError[target] || Object.keys(obj).includes(target)) return obj;
      return { ...obj, [target]: message };
    }, {});
    console.log({ errorMap });
    return errorMap;
  }, [ isShowError, valids ]);

  // 入力チェック（全体）
  useEffect(()=> {
    const [ isValid, newErrorMessages ] = isSchemaValid({
      target: {
        workCategory,
        workCategorySub,
        workCategoryOtherDetail,
        workDetailText,
        employmentPlacementDispatching,
        companyNameText,
        dept,
        chargePersonNameText,
        tel,
        email,
        address,
        ekiCd,
        ekiName,
      },
    });

    console.log('valid:schema', { isValid, newErrorMessages });
    console.log(`valid out vaid schema ${ valid}`);
    // erros更新
    const newValid = { schema: { valid: isValid, errorMessages: newErrorMessages } };
    setValids(org => ({ ...org, ...newValid }));
  }, [ workCategory, workCategorySub, workCategoryOtherDetail, workDetailText, companyNameText, chargePersonNameText, tel, email, address, ekiName, ekiCd, valid, dept, employmentPlacementDispatching ]);
  
  // 相関チェック
  // 職種サブカテゴリの必須チェック
  useEffect(() => {
    const workCategorySubValidation = async () => {
      // エラーチェックを実行
      const [ isValid, newErrorMessages ] = await isCustomValid({
        checks: [ 'checkWorkCategoryRequire' ],
        target: { workCategory, workCategorySub },
      });

      // erros更新
      const newValid = { checkWorkCategoryRequire: { valid: isValid, errorMessages: newErrorMessages } };
      setValids(org => ({ ...org, ...newValid }));
    };
    workCategorySubValidation();
  }, [ workCategory, workCategorySub ]);


  // onChange
  const onChangeWorkCategory = (e) =>{
    setWorkCategory(e.target.value);
    setWorkCategorySub([]);
    setWorkCategoryOtherDetail('');
  };

  const onChangeWorkCategorySub = (val) =>{
    if (workCategorySub.includes(val)) {
      setWorkCategorySub(workCategorySub.filter(item => item !== val));
    } else {
      setWorkCategorySub([ ...workCategorySub, val ]);
    } 
  };

  const onChangeWorkCategoryOtherDetail = (e) =>{
    setWorkCategoryOtherDetail(e.target.value);
    if(!isShowError.workCategoryOtherDetail) {
      setIsShowError({ ...isShowError, workCategoryOtherDetail: true });
    }
  };

  const onChangeWorkDetailText = (e) =>{
    setWorkDetailText(e.target.value);
    if(!isShowError.workDetailText) {
      setIsShowError({ ...isShowError, workDetailText: true });
    }
  };

  const onChangeEmploymentPlacementDispatching = () =>{
    if (employmentPlacementDispatching) {
      setEmploymentPlacementDispatching(false);
    } else {
      setEmploymentPlacementDispatching(true);
    } 
  };

  // 企業名入力
  const onChangeCompanyNameText = async (e) =>{
    setCompanyNameText(e.target.value);
    if(!isShowError.companyNameText) {
      setIsShowError({ ...isShowError, companyNameText: true });
    }
  };

  const onChangeDept = (e) =>{
    setDept(e.target.value);

    if(!isShowError.dept) {
      setIsShowError({ ...isShowError, dept: true });
    }
  };


  const onChangeChargePersonNameText = (e) =>{
    setChargePersonNameText(e.target.value);
    if(!isShowError.chargePersonNameText) {
      setIsShowError({ ...isShowError, chargePersonNameText: true });
    }
  };

  const onChangeTel = (e) =>{
    setTel(e.target.value);

    if(!isShowError.tel) {
      setIsShowError({ ...isShowError, tel: true });
    }
  };

  const onChangeEmail = (e) =>{
    setEmail(e.target.value);

    if(!isShowError.email) {
      setIsShowError({ ...isShowError, email: true });
    }
  };

  const onChangeAddress = (e) =>{
    setAddress(e.target.value);
    if(!isShowError.address) {
      setIsShowError({ ...isShowError, address: true });
    }
  };

  // 駅入力
  // サジェスト表示タイマー
  const ekiSuggestTimer = async (searchText) => {
    const id = setTimeout(() => {
      ekiSuggestApi({ searchText }).then((value)=> {
        setEkiSuggestNames(value);
        // サジェストあり
        if(value.length > 0) {
          const newValid = {
            ekiSuggestZero: {
              valid: true,
              errorMessages: [],
            },
          };
          setModalBackIsEnable(true);
          setValids(org => ({ ...org, ...newValid }));
        }else{
          setModalBackIsEnable(false);
        }
      }).catch(err => {
        setModalBackIsEnable(false);
        // FATELエラーチェック
        const isFatal = isFatalApiError(err);
        setIsApiError(isFatal);
        if(isFatal) throw err;
        // 駅サジェスト0件
        if(err.response.status === 404){
          setEkiSuggestNames([]);
          // erros更新
          const newValid = {
            ekiSuggestZero: {
              valid: false,
              errorMessages: [ new ErrorMessage('ekiName', CUSTOM_ERROR_MESSAGES.ekiSuggestZero, 1) ],
            },
          };
          setValids(org => ({ ...org, ...newValid }));
        } 
        return [];
      });
      // ekiNameエラー表示開始
      if(!isShowError.ekiName) {
        setIsShowError({
          ...isShowError,
          ...{
            ekiName: true,
            ekiCd: true,
          },
        });
      }
    }, 200, searchText);
    return id;
  };

  // 駅名入力時
  const onChangeEkiname = async (e) => {
    console.log(`nativeEvent.inputType: ${e.nativeEvent.inputType}`);
    // safariのdeleteCompositionTextを無視
    if(e.nativeEvent.inputType === 'deleteCompositionText' || e.nativeEvent.inputType === 'insertFromComposition'){
      return;
    }
    
    const searchText = e.target.value;
    setEkiName(searchText);
    setEkiCd('');
    setSelectedEkiCd('');

    // 先行タイマー停止
    clearTimeout(timerId);
    // タイマー設定
    setTimerId(await ekiSuggestTimer(searchText));
  };

  // 駅サジェストクリック時
  const onClickEkiSuggest = async ( idx ) => {
    const clicked = ekiSuggestNames[idx];
    setEkiName(clicked.ekiNm);
    setEkiCd(clicked.ekiCd);
    setSelectedEkiCd(clicked.ekiCd);
    setEkiSuggestNames([]);
    setModalBackIsEnable(false);
  };

  // ボタン押下
  // state更新処理
  const updateState = ()=>{
    dispatch({
      type: UPDATE_INPUT,
      updInput: { 
        workCategory,
        workCategorySub,
        workCategoryOtherDetail,
        workDetailText,
        employmentPlacementDispatching,
        companyNameText,
        dept,
        chargePersonNameText,
        tel,
        email,
        address,
        ekiCd: selectedEkiCd,
        ekiName,
        clickID,
        mediaID,
      },
    });
  };

  const onClickMainButton = {
    prev: () => {
      scrollTop();
      updateState();
    },
    next: () => {
      scrollTop();
      updateState();
      dispatch({
        type: CHANGE_VALID, 
        path,
        valid,
      });
    },
  };

  // 画面項目
  const {
    workCategoryList,
    workOfficeTypeList,
    workITTypeList,
    workMarketingTypeList,
  } = CHOICES_MAP;
  
  const WorkOfficeType = workOfficeTypeList.map((value) => ({
    value: value.value,
    label: value.label,
    checkBoxOnChange: () => onChangeWorkCategorySub(value.value),
    checked: workCategorySub.includes(value.value),
    id: value.value,
  }));
  
  const WorkITType = workITTypeList.map((value) => ({
    value: value.value,
    label: value.label,
    checkBoxOnChange: () => onChangeWorkCategorySub(value.value),
    checked: workCategorySub.includes(value.value),
    id: value.value,
  }));
  
  const WorkMarketingType = workMarketingTypeList.map((value) => ({
    value: value.value,
    label: value.label,
    checkBoxOnChange: () => onChangeWorkCategorySub(value.value),
    checked: workCategorySub.includes(value.value),
    id: value.value,
  }));
  
  const checkList = { 'A': WorkOfficeType, 'B': WorkITType, 'C': WorkMarketingType };
  
  const WorkCategoryList = {
    dataList: workCategoryList,
    checkList,
  };
  

  return isSp ? (
    <PresentSP
      // state
      workCategory={workCategory}
      workCategoryOtherDetail={workCategoryOtherDetail}
      workDetailText={workDetailText}
      employmentPlacementDispatching={employmentPlacementDispatching}
      companyNameText={companyNameText}
      dept={dept}
      chargePersonNameText={chargePersonNameText}
      tel={tel}
      email={email}
      address={address}
      ekiName={ekiName}
      ekiSuggestNames={ekiSuggestNames}

      WorkCategoryList={WorkCategoryList}

      // onChange
      onChangeWorkCategory={onChangeWorkCategory}
      onChangeWorkCategoryOtherDetail={onChangeWorkCategoryOtherDetail}
      onChangeWorkDetailText={onChangeWorkDetailText}
      onChangeEmploymentPlacementDispatching={onChangeEmploymentPlacementDispatching}
      onChangeCompanyNameText={onChangeCompanyNameText}
      onChangeDept={onChangeDept}
      onChangeChargePersonNameText={onChangeChargePersonNameText}
      onChangeTel={onChangeTel}
      onChangeEmail={onChangeEmail}
      onChangeAddress={onChangeAddress}
      onChangeEkiname={onChangeEkiname}
      modalBackIsEnable={modalBackIsEnable}
      // onClick
      onClickMainButton={onClickMainButton}
      onClickEkiSuggest={onClickEkiSuggest}
  
      // valid
      valid={valid}
      errorDispMap={dispErrors()}
      isApiError={isApiError}
    /> 
  ) : (
    <PresentPC
      // state
      workCategory={workCategory}
      workCategoryOtherDetail={workCategoryOtherDetail}
      workDetailText={workDetailText}
      employmentPlacementDispatching={employmentPlacementDispatching}
      companyNameText={companyNameText}
      dept={dept}
      chargePersonNameText={chargePersonNameText}
      tel={tel}
      email={email}
      address={address}
      ekiName={ekiName}
      ekiSuggestNames={ekiSuggestNames}

      WorkCategoryList={WorkCategoryList}

      // onChange
      onChangeWorkCategory={onChangeWorkCategory}
      onChangeWorkCategoryOtherDetail={onChangeWorkCategoryOtherDetail}
      onChangeWorkDetailText={onChangeWorkDetailText}
      onChangeEmploymentPlacementDispatching={onChangeEmploymentPlacementDispatching}
      onChangeCompanyNameText={onChangeCompanyNameText}
      onChangeDept={onChangeDept}
      onChangeChargePersonNameText={onChangeChargePersonNameText}
      onChangeTel={onChangeTel}
      onChangeEmail={onChangeEmail}
      onChangeAddress={onChangeAddress}
      onChangeEkiname={onChangeEkiname}
      modalBackIsEnable={modalBackIsEnable}

      // onClick
      onClickEkiSuggest={onClickEkiSuggest}
      onClickMainButton={onClickMainButton}

      // valid
      valid={valid}
      errorDispMap={dispErrors()}
      isApiError={isApiError}
    />
  );

};

export default Input;